var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOssAndTools = function SvgOssAndTools(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#oss-and-tools_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    d: "m21.667 23.333-5-5m8.35-12.5v-2.5m6.566 5.101 1.768-1.767m-1.768 15 1.768 1.767m-15-15-1.768-1.767M34.184 15h2.5M10.22 34.781l15.396-15.395c.66-.66.99-.99 1.113-1.37a1.67 1.67 0 0 0 0-1.031c-.123-.38-.453-.71-1.113-1.37l-1.23-1.23c-.66-.66-.99-.99-1.37-1.113a1.67 1.67 0 0 0-1.03 0c-.38.124-.71.454-1.37 1.114L5.219 29.78c-.66.66-.99.99-1.114 1.37a1.67 1.67 0 0 0 0 1.03c.124.381.454.711 1.114 1.371l1.229 1.23c.66.66.99.99 1.37 1.113.335.108.696.108 1.03 0 .381-.124.711-.454 1.371-1.114"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "oss-and-tools_svg__a",
    x1: 33.787,
    x2: -31.477,
    y1: 4.235,
    y2: 29.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgOssAndTools;